import { Routes, Route, Navigate } from "react-router-dom";
import { AppLayout } from "@/components/app-layout";
import { AuthGate } from "@/components/auth-gate";
import DashboardPage from "@/pages/dashboard";
import PayerDirectoryPage from "@/pages/payer-directory";
import CallsPage from "@/pages/calls";
import CasesPage from "@/pages/cases";
import DailyIntakePage from "@/pages/intake";
import RetryConsolePage from "@/pages/retry";
import WebhookFailuresPage from "@/pages/webhook-failures";
import PatientRegistryPage from "@/pages/patients";
import PhoneNumbersPage from "@/pages/phone-numbers";

function App() {
  return (
    <AuthGate>
      <Routes>
        <Route element={<AppLayout />}>
          <Route index element={<DashboardPage />} />
          <Route path="/payer-directory" element={<PayerDirectoryPage />} />
          <Route path="/phone-numbers" element={<PhoneNumbersPage />} />
          <Route path="/intake" element={<DailyIntakePage />} />
          <Route path="/retry" element={<RetryConsolePage />} />
          <Route path="/webhook-failures" element={<WebhookFailuresPage />} />
          <Route path="/patients" element={<PatientRegistryPage />} />
          <Route path="/calls" element={<CallsPage />} />
          <Route path="/cases" element={<CasesPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthGate>
  );
}

export default App;
